import React from 'react';
import { Route } from 'react-router-dom';
import Load from 'components/Load';
import basePath from 'utils/basePath';

const AsyncContactModalSuccess = Load(() => import(/* webpackChunkName: "contact-modal" */'modules/experience/containers/ContactModalSuccessContainer'), {}, true);
const AsyncContactModalSending = Load(() => import(/* webpackChunkName: "contact-modal" */'./containers/ContactModalSendingContainer'), {}, true);
const AsyncContactModal = Load(() => import(/* webpackChunkName: "contact-modal" */'modules/experience/containers/ContactModalContainer'), {}, true);
const AsyncHostVideoModal = Load(() => import(/* webpackChunkName: "host-video-modal" */'./containers/HostVideoModalContainer'), {}, true);
const AsyncHostOfferPeopleSelector = Load(() => import(/* webpackChunkName: "host-offer-people-modal" */'modules/experience/containers/HostOfferPeopleSelectorContainer'), {}, true);
const AsyncHostOfferDateTimePicker = Load(() => import(/* webpackChunkName: "host-offer-datepicker-modal" */'modules/experience/containers/HostOfferDateTimePickerModalContainer'), {}, true);
const AsyncInstantlyConfirmedModal = Load(() => import(/* webpackChunkName: "how-it-works-modal-exp-page" */'components/HowItWorksModal/InstantlyConfirmedModal'));
const AsyncFamilyFriendlyHowItWorks = Load(() => import(/* webpackChunkName: "how-it-works-modal-exp-page" */'components/HowItWorksModal/FamilyFriendlyHowItWorks'));
const AsyncShareExperienceModal = Load(() => import(/* webpackChunkName: "share-experience-modal" */'./containers/ShareExperienceModalContainer'), {}, true);


const ExperienceModalRoutes = [
  (
    <Route key="contact.modal.success" path={`${basePath}/experience/:id/contact/:hostId/success/`} component={AsyncContactModalSuccess} />
  ), (
    <Route key="contact.modal.sending" path={`${basePath}/experience/:id/contact/:hostId/sending/`} component={AsyncContactModalSending} />
  ), (
    <Route key="contact.modal" path={`${basePath}/experience/:id/contact/:hostId/:form/`} component={AsyncContactModal} />
  ), (
    <Route key="experience.modal.video" path={`${basePath}/experience/:id/video/:hostId/`} component={AsyncHostVideoModal} />
  ), (
    <Route key="experience.modal.guests" path={`${basePath}/experience/:id/filters/guests/`} component={AsyncHostOfferPeopleSelector} />
  ), (
    <Route key="experience.modal.date.time" path={`${basePath}/experience/:id/filters/date-time/`} component={AsyncHostOfferDateTimePicker} />
  ), (
    <Route key="experience.modal.instantly-confirmed" path={`${basePath}/experience/instantly-confirmed/`} exact component={AsyncInstantlyConfirmedModal} />
  ), (
    <Route key="experience.modal.family-friendly" path={`${basePath}/experience/family-friendly/`} exact component={AsyncFamilyFriendlyHowItWorks} />
  ), (
    <Route key="experience.modal.share" path={`${basePath}/experience/:id/share/:otherId?`} component={AsyncShareExperienceModal} />
  ),
];

export default ExperienceModalRoutes;
